<template>
  <div class="container py-2">
    <div class="status-wrapper">

      <div class="status-header">
        <h3>
          {{
            statusSanggahan
              ? "Data Pengaju Sanggahan"
              : milik === 3
                ? "Konfirmasi Pelapor"
                : pengemudi
                  ? "Konfirmasi Pengemudi"
                  : "Data Pengemudi Sebenarnya"
          }}
        </h3>
        <p class="instruction-text">Informasi status dan kelengkapan data pelanggaran.</p>
      </div>

      <form @submit.prevent="submitForm">
        <div class="table-responsive">
          <table class="modern-table">
            <tbody>

              <tr>
                <td colspan="2">
                  <div class="alert-box">
                    <strong>Pemberitahuan:</strong><br>
                    {{
                      pengemudi
                        ? "Berikan Informasi pelanggar sesuai dengan kondisi yang sebenarnya."
                        : "Silakan isi data pengemudi yang sebenarnya pada saat pelanggaran terjadi."
                    }}
                  </div>
                </td>
              </tr>

              <tr v-if="milik !== 4">
                <th class="question-header">
                  Apakah Saudara adalah Pengemudi Kendaraan pada Saat Pelanggaran Terjadi?
                </th>
                <td>
                  <div class="simple-choice">
                    <label class="choice-item">
                      <input type="radio" id="pengemudi_ya" name="pengemudi" :value="true" v-model="pengemudi" />
                      <span>Ya</span>
                    </label>
                    <label class="choice-item">
                      <input type="radio" id="pengemudi_bukan" name="pengemudi" :value="false" v-model="pengemudi" />
                      <span>Bukan</span>
                    </label>
                  </div>
                </td>
              </tr>

              <tr class="section-row">
                <td colspan="2">Isi Data Diri</td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Nama Lengkap" : "Nama Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <input v-model="formData.nama" type="text" id="nama" class="form-control" pattern="^[A-Za-z\s\-]+$"
                    title="Nama hanya boleh mengandung huruf, spasi, dan tanda hubung." required />
                </td>
              </tr>

              <tr>
                <th>Jenis Kelamin <span class="text-danger">*</span></th>
                <td>
                  <select v-model="formData.jeniskelamin" id="jeniskelamin" class="form-control" required>
                    <option value="" disabled>Pilih Jenis Kelamin</option>
                    <option value="Laki-laki">Laki-laki</option>
                    <option value="Perempuan">Perempuan</option>
                  </select>
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "No. Telepon" : "No. Telepon Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <input v-model="formData.notel" type="tel" id="notel" class="form-control"
                    @input="validatePhoneNumber" pattern="^(62|0)8[1-9][0-9]{7,11}$"
                    title="Nomor telepon harus dimulai dengan 08 atau 628 dengan panjang 10–14 angka" minlength="10"
                    maxlength="14" required />
                  <span v-if="phoneError" class="text-danger d-block mt-1 small">{{ phoneError }}</span>
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Alamat Domisili" : "Alamat Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <input v-model="formData.alamat" type="text" id="alamat" class="form-control" required />
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Email Aktif" : "Email Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <input v-model="formData.email" type="email" id="email" class="form-control" required />
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Tempat Lahir" : "Tempat Lahir Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <input v-model="formData.tempatlahir" type="text" id="tempatlahir" class="form-control" required />
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Tanggal Lahir" : "Tanggal Lahir Pengemudi" }} <span class="text-danger">*</span>
                </th>
                <td>
                  <datetime v-model="formData.ttl" type="date" input-class="form-control" placeholder="dd/mm/yyyy"
                    :format="'dd/MM/yyyy'" required></datetime>
                </td>
              </tr>

              <tr>
                <th>{{ pengemudi ? "Pilih Identitas" : "Identitas Pengemudi" }} <span class="text-danger">*</span></th>
                <td>
                  <select v-model="formData.identity" id="identity" class="form-control" required>
                    <option value="" disabled>Pilih Identitas</option>
                    <option value="2">SIM</option>
                  </select>
                </td>
              </tr>

              <template v-if="formData.identity === '2'">
                <tr class="section-row">
                  <td colspan="2">Dokumen SIM</td>
                </tr>
                <tr>
                  <th>Golongan SIM <span class="text-danger">*</span></th>
                  <td>
                    <select v-model="formData.golonganSim" id="golongansim" class="form-control" required>
                      <option value="" disabled>Pilih Golongan SIM</option>
                      <option value="SIM A">SIM A</option>
                      <option value="SIM A Umum">SIM A Umum</option>
                      <option value="SIM B - I">SIM B - I</option>
                      <option value="SIM B - II">SIM B - II</option>
                      <option value="SIM B - II">SIM B - II Umum</option>
                      <option value="SIM B Umum">SIM B Umum</option>
                      <option value="SIM C">SIM C</option>
                      <option value="SIM C - I">SIM C - I</option>
                      <option value="SIM C - II">SIM C - II</option>
                      <option value="SIM D">SIM D</option>
                      <option value="SIM D - I">SIM D - I</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>No SIM <span class="text-danger">*</span></th>
                  <td>
                    <input v-model="formData.noSim" type="text" id="noSim" class="form-control" pattern="^\d{14,16}$"
                      maxlength="16" title="No SIM harus terdiri dari 14 hingga 16 digit angka" required />
                  </td>
                </tr>
                <tr>
                  <th>Masa Berlaku SIM <span class="text-danger">*</span></th>
                  <td>
                    <datetime v-model="formData.masaBerlakuSim" type="date" input-class="form-control"
                      placeholder="dd/mm/yyyy" :format="'dd/MM/yyyy'" required></datetime>
                  </td>
                </tr>
                <tr>
                  <th>Pendidikan</th>
                  <td>
                    <select v-model="formData.id_pendidikan" id="pendidikan" class="form-control"
                      @change="updatePendidikanText">
                      <option value="" disabled>Pilih Pendidikan</option>
                      <option v-for="pendidikan in masterData.pendidikan" :key="pendidikan.id" :value="pendidikan.id">
                        {{ pendidikan.nama }}
                      </option>
                    </select>
                    <input type="hidden" v-model="formData.pendidikan" />
                  </td>
                </tr>
                <tr>
                  <th>Pekerjaan</th>
                  <td>
                    <select v-model="formData.id_pekerjaan" id="pekerjaan" class="form-control"
                      @change="updatePekerjaanText">
                      <option value="" disabled>Pilih Pekerjaan</option>
                      <option v-for="pekerjaan in masterData.pekerjaan" :key="pekerjaan.id" :value="pekerjaan.id">
                        {{ pekerjaan.nama }}
                      </option>
                    </select>
                    <input type="hidden" v-model="formData.pekerjaan" />
                  </td>
                </tr>
                <tr>
                  <th>Satpas Penerbit</th>
                  <td>
                    <input v-model="formData.satpasPenerbit" type="text" id="satpasPenerbit" class="form-control"
                      placeholder="Contoh: Satpas Polda Metro Jaya" />
                  </td>
                </tr>
                <tr>
                  <th>
                    {{ pengemudi ? "Upload SIM" : "Upload SIM Pengemudi" }}
                    <span class="text-danger">*</span>
                  </th>

                  <td>
                    <div v-if="!formData.uploadSim">
                      <input type="file" id="uploadSim" @change="handleFileUploadSim" accept=".jpg,.jpeg,.png,.pdf"
                        required />

                      <small class="file-helper">
                        Hanya format JPG, JPEG, PNG, dan PDF yang diterima
                        (maksimal 2MB).
                      </small>
                    </div>

                    <div v-else class="tabs">
                      <button type="button" class="tab-btn btn-danger-custom" @click.prevent="removeSim">
                        Hapus & Ulangi SIM
                      </button>
                    </div>
                  </td>
                </tr>

                <tr v-if="formData.uploadSim">
                  <td colspan="2" class="media-full-cell">
                    <div class="media-box-full">
                      <img v-if="simPreview" :src="simPreview" alt="Preview Dokumen SIM" class="fullFrame-view" />

                      <div v-else-if="formData.uploadSim.type === 'application/pdf'">
                        Dokumen PDF: {{ formData.uploadSim.name }}
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

            </tbody>
          </table>
        </div>
        <div class="disclaimer-box">
          <h5>
            <i class="bi bi-exclamation-circle-fill"></i>
            Pernyataan
          </h5>

          <p>Dengan ini saya menyatakan bahwa:</p>

          <ol>
            <li>Benar bahwa pelanggaran lalu lintas ini telah terjadi.</li>
            <li>Bersedia untuk penggunaan konfirmasi sebagai pengganti tanda tangan pada blanko tilang.</li>
          </ol>

          <div class="form-check mt-3">
            <input class="form-check-input" type="checkbox" id="agreeDisclaimer" v-model="agreeDisclaimer" />
            <label class="form-check-label" for="agreeDisclaimer">
              Saya telah membaca, memahami, dan menyetujui pernyataan di atas.
            </label>
          </div>
        </div>
        <div class="action-group">
          <button type="button" class="btn-back" @click="$emit('prev')">
            <i class="bi bi-arrow-left"></i> Kembali
          </button>
          <button type="submit" class="btn-next" :disabled="!agreeDisclaimer || isSubmitting">
            <span v-if="isSubmitting">
              <i class="spinner-border spinner-border-sm me-1"></i> Memproses...
            </span>
            <span v-else>
              Submit Kirim <i class="bi bi-check-circle"></i>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { postDetailsKonfirmasi, postKonfirmasiPelanggar, masterPendidikanPekerjaan, postKonfirmasiLitsus, getPenerbitanBriva } from "./api";
import Swal from "sweetalert2";
import Vue from "vue";

export default {
  props: {
    noReferensi: {
      type: String,
      required: true,
    },
    noPolisi: {
      type: String,
      required: true,
    },
    pelanggaranData: {
      type: Array,
      default: () => [],
    },
    confirmationType: {
      type: [String, Number],
      default: null
    },
    milik: {
      type: [String, Number],
      required: true,
      default: null
    },
    uploadBukti: {
      type: [Object, File],
      default: null
    },
    alasan: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: ""
    },

    idTipeSanggahan: {
      type: [String, Number],
      default: null
    },
    namaTipeSanggahan: {
      type: String,
      default: ""
    },
    step4Data: {
      handler(newVal) {

        if (!newVal || !newVal.formData) return;

        this.formData = {
          ...this.formData,
          ...newVal.formData
        };

        this.pengemudi = newVal.pengemudi ?? this.pengemudi;
        this.simPreview = newVal.simPreview ?? this.simPreview;
        this.fotoPreview = newVal.fotoPreview ?? this.fotoPreview;

      },
      deep: true
    },
  },

  data() {
    return {
      isSubmitting: false,
      formData: {
        nama: "",
        jeniskelamin: "",
        notel: "",
        alamat: "",
        email: "",
        tempatlahir: "",
        ttl: "",
        pendidikan: "",
        pekerjaan: "",
        id_pendidikan: "",
        id_pekerjaan: "",
        identity: "",
        noKtp: "",
        uploadKtp: null,
        golonganSim: "",
        noSim: "",
        masaBerlakuSim: "",
        satpasPenerbit: "",
        uploadSim: null,
        foto: null,
      },
      agreeDisclaimer: false,
      statusData: null,
      phoneError: "",
      pengemudi: true,
      fotoPreview: null,
      simPreview: null,
      masterData: {
        pendidikan: [],
        pekerjaan: []
      },
    };
  },

  computed: {
    statusSanggahan() {
      return this.milik === 2;
    },

    hasSavedState() {
      return !!(
        this.step4Data &&
        this.step4Data.formData &&
        Object.keys(this.step4Data.formData).length > 0
      );
    }
  },

  watch: {

    formData: {
      handler() {
        this.saveStep4();
      },
      deep: true
    },

    simPreview() {
      this.saveStep4();
    },

    fotoPreview() {
      this.saveStep4();
    },

    pengemudi(newVal, oldVal) {

      if (newVal === oldVal) return;

      if (this.milik === 2) {
        this.saveStep4();
        return;
      }

      if (newVal) {
        this.fillPemilikData(true);
      } else {
        this.clearFormData();
        this.removeFoto();
        this.removeSim();
      }

      this.saveStep4();
    },
  },

  async mounted() {
    await this.loadMasterData();

    if (this.pelanggaranData && this.pelanggaranData.length > 0) {
      this.statusData = this.pelanggaranData[0];
    } else {
      await this.checkStatus();
    }

    if (this.hasSavedState) {

      this.formData = {
        ...this.formData,
        ...this.step4Data.formData
      };

      this.pengemudi = this.step4Data.pengemudi ?? true;
      this.simPreview = this.step4Data.simPreview ?? null;
      this.fotoPreview = this.step4Data.fotoPreview ?? null;

      return;
    }

    this.populateFormData();
  },

  methods: {

    saveStep4() {
      this.$emit("save", {
        formData: {
          ...this.formData
        },
        pengemudi: this.pengemudi,
        simPreview: this.simPreview,
        fotoPreview: this.fotoPreview
      });
    },

    async loadMasterData() {
      try {
        const response = await masterPendidikanPekerjaan();
        this.masterData = response.data || response;
      } catch (error) {
        console.error("Error loading master data:", error);
        Swal.fire({
          title: "Kesalahan!",
          text: "Gagal memuat data pendidikan dan pekerjaan.",
          icon: "error",
        });
      }
    },

    fillPemilikData(force = false) {
      if (this.hasSavedState && !force) {
        return;
      }

      if (!this.statusData) return;

      if (this.statusData.fr_image !== null && this.statusData.fr_nama) {
        this.formData.nama = this.statusData.fr_nama || "";
        this.formData.alamat = this.statusData.fr_alamat || "";
        this.formData.tempatlahir = this.statusData.fr_tempat_lahir || "";
        this.formData.ttl = this.statusData.fr_ttl ? this.convertDateFormat(this.statusData.fr_ttl) : "";
      } else {
        this.formData.nama = this.statusData.pemilik || "";
        this.formData.alamat = this.statusData.Alamat || "";
        this.formData.tempatlahir = this.statusData.tempatlahir || "";
        this.formData.ttl = this.statusData.ttl || "";
      }

      this.formData.notel = this.statusData.notel || "";
      this.formData.email = this.statusData.email || "";
    },

    updatePendidikanText() {
      const selectedPendidikan = this.masterData.pendidikan.find(
        item => item.id === this.formData.id_pendidikan
      );
      if (selectedPendidikan) {
        this.formData.pendidikan = selectedPendidikan.nama;
      }
    },
    updatePekerjaanText() {
      const selectedPekerjaan = this.masterData.pekerjaan.find(
        item => item.id === this.formData.id_pekerjaan
      );
      if (selectedPekerjaan) {
        this.formData.pekerjaan = selectedPekerjaan.nama;
      }
    },
    async handleFotoUpload(event) {
      const file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024;

      if (file) {
        if (file.size > maxSize) {
          Swal.fire({
            title: "Kesalahan!",
            text: "Maksimal Upload Foto 2 MB.",
            icon: "error",
          });
          event.target.value = "";
          this.formData.foto = null;
          this.fotoPreview = null;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.formData.foto = e.target.result;
            this.fotoPreview = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      }
    },
    removeFoto() {
      this.formData.foto = null;
      this.fotoPreview = null;
      this.$nextTick(() => {
        if (this.$refs.fotoInput) {
          this.$refs.fotoInput.value = "";
        }
      });
      this.saveStep4();
    },
    handleFileUploadSim(event) {
      const file = event.target.files[0];

      if (!file) return;

      const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
      const extension = file.name.split(".").pop().toLowerCase();

      const allowedMimeTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
      ];

      if (
        !allowedExtensions.includes(extension) ||
        !allowedMimeTypes.includes(file.type)
      ) {
        Swal.fire({
          icon: "error",
          title: "File Tidak Sesuai",
          text: "File harus berformat JPG, JPEG, PNG, atau PDF.",
        });

        event.target.value = "";
        this.formData.uploadSim = null;
        this.simPreview = null;
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Ukuran File Terlalu Besar",
          text: "Ukuran file maksimal 2 MB.",
        });

        event.target.value = "";
        this.formData.uploadSim = null;
        this.simPreview = null;
        return;
      }

      this.formData.uploadSim = file;

      if (file.type === "application/pdf") {
        this.simPreview = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.simPreview = e.target.result;
      };

      reader.readAsDataURL(file);
    },

    removeSim() {
      this.formData.uploadSim = null;
      this.simPreview = null;

      const input = this.$el.querySelector("#uploadSim");

      if (input) {
        input.value = "";
      }

      this.saveStep4();
    },
    validatePhoneNumber() {
      this.formData.notel = this.formData.notel.replace(/[^0-9]/g, '');

      const phone = this.formData.notel;

      if (!phone) {
        this.phoneError = 'Nomor telepon wajib diisi.';
      } else if (!/^(62|0)8/.test(phone)) {
        this.phoneError = 'Nomor telepon harus dimulai dengan 08 atau 628.';
      } else if (phone.length < 10 || phone.length > 14) {
        this.phoneError = 'Panjang nomor telepon harus antara 10 hingga 14 digit.';
      } else {
        this.phoneError = '';
      }
    },
    async checkStatus() {
      try {
        const formData = new FormData();
        formData.append("no_ref", this.noReferensi);
        formData.append("no_plat", this.noPolisi);

        const response = await postDetailsKonfirmasi(formData);
        this.statusData = response.data.length > 0 ? response.data[0] : null;
        this.populateFormData();
      } catch (error) {
        Swal.fire({
          title: "Kesalahan!",
          text: "Terjadi kesalahan saat memeriksa status pelanggaran.",
          icon: "error",
        });
        console.error("Error fetching status:", error);
      }
    },
    async populateFormData() {

      if (this.hasSavedState) {
        return;
      }

      if (this.statusData) {
        Vue.set(this.formData, "notel", this.statusData.notel || "");
        Vue.set(this.formData, "email", this.statusData.email || "");

        const pendidikanText = this.statusData.fr_pendidikan || this.statusData.pendidikan || "";
        Vue.set(this.formData, "pendidikan", pendidikanText);
        Vue.set(this.formData, "id_pendidikan", "");

        if (pendidikanText && this.masterData.pendidikan.length > 0) {
          const pendidikanMatch = this.masterData.pendidikan.find(
            item => item.nama.toLowerCase() === pendidikanText.toLowerCase()
          );
          if (pendidikanMatch) {
            Vue.set(this.formData, "id_pendidikan", pendidikanMatch.id);
          }
        }

        const pekerjaanText = this.statusData.fr_pekerjaan || this.statusData.pekerjaan || "";
        Vue.set(this.formData, "pekerjaan", pekerjaanText);
        Vue.set(this.formData, "id_pekerjaan", "");

        if (pekerjaanText && this.masterData.pekerjaan.length > 0) {
          const pekerjaanMatch = this.masterData.pekerjaan.find(
            item => item.nama.toLowerCase() === pekerjaanText.toLowerCase()
          );
          if (pekerjaanMatch) {
            Vue.set(this.formData, "id_pekerjaan", pekerjaanMatch.id);
          }
        }

        if (this.statusData && this.statusData?.fr_image !== null) {
          Vue.set(this.formData, "identity", "1");
          Vue.set(this.formData, "nama", this.statusData.fr_nama || "");
          Vue.set(this.formData, "alamat", this.statusData.fr_alamat || "");
          Vue.set(this.formData, "tempatlahir", this.statusData.fr_tempat_lahir || "");
          Vue.set(this.formData, "ttl", this.convertDateFormat(this.statusData.fr_ttl) || "");
          Vue.set(this.formData, "noKtp", this.statusData.no_ktp || "");

          const imageUrl = `${process.env.VUE_APP_API_URL}/images_fr/${this.statusData.fr_image}`;
          try {
            const response = await fetch(imageUrl);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
              Vue.set(this.formData, "foto", reader.result);
              this.fotoPreview = reader.result;
              this.saveStep4();
            };
            reader.readAsDataURL(blob);
          } catch (error) {
            console.error("Error fetching image:", error);
            Vue.set(this.formData, "foto", null);
            this.fotoPreview = null;
          }
        } else {
          Vue.set(this.formData, "nama", this.statusData.pemilik || "");
          Vue.set(this.formData, "alamat", this.statusData.Alamat || "");
          Vue.set(this.formData, "tempatlahir", this.statusData.tempatlahir || "");
          Vue.set(this.formData, "ttl", this.statusData.ttl || "");
        }

        if (this.statusData.identity) {
          Vue.set(this.formData, "identity", this.statusData.identity);
          if (this.statusData.identity === "1") {
            Vue.set(this.formData, "noKtp", this.statusData.noKtp || "");
          } else if (this.statusData.identity === "2") {
            Vue.set(this.formData, "golonganSim", this.statusData.golonganSim || "");
            Vue.set(this.formData, "noSim", this.statusData.noSim || "");
            Vue.set(this.formData, "masaBerlakuSim", this.statusData.masaBerlakuSim || "");
            Vue.set(this.formData, "satpasPenerbit", this.statusData.satpasPenerbit || "");
          }
        }
      }
    },
    clearFormData() {
      this.formData.nama = "";
      this.formData.jeniskelamin = "";
      this.formData.notel = "";
      this.formData.alamat = "";
      this.formData.email = "";
      this.formData.tempatlahir = "";
      this.formData.ttl = "";
      this.formData.pendidikan = "";
      this.formData.pekerjaan = "";
      this.formData.id_pendidikan = "";
      this.formData.id_pekerjaan = "";
      this.formData.identity = "";
      this.formData.noKtp = "";
      this.formData.uploadKtp = null;
      this.formData.golonganSim = "";
      this.formData.noSim = "";
      this.formData.masaBerlakuSim = "";
      this.formData.satpasPenerbit = "";
      this.formData.uploadSim = null;
      this.formData.foto = null;
      this.simPreview = null;
    },

    async submitForm() {
      const formElement = this.$el.querySelector("form");
      if (!formElement.checkValidity()) {
        formElement.reportValidity();
        return;
      }
      if (this.isSubmitting) return;
      Swal.fire({
        title: "Disclaimer!",
        text: "Pastikan semua informasi yang Anda masukkan sudah benar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Tidak, Saya Cek lagi",
        confirmButtonText: "Ya, Sudah Benar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (this.isSubmitting) return;
          this.isSubmitting = true;

          Swal.fire({
            title: "Sedang Memproses...",
            text: "Menyimpan data konfirmasi Anda, harap tunggu.",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          try {
            const submitData = new FormData();
            submitData.append("nama", this.formData.nama);
            submitData.append("notel", this.formData.notel);
            submitData.append("wilayah", this.statusData?.wilayah || "");
            submitData.append("alamat", this.formData.alamat);
            submitData.append("email", this.formData.email);
            submitData.append("tempatlahir", this.formData.tempatlahir);
            submitData.append("jenis_kelamin", this.formData.jeniskelamin);
            submitData.append("milik", this.milik);
            submitData.append("pengemudi", this.pengemudi);
            submitData.append("pendidikan", this.formData.pendidikan);
            submitData.append("pekerjaan", this.formData.pekerjaan);
            submitData.append("id_pendidikan", this.formData.id_pendidikan);
            submitData.append("id_pekerjaan", this.formData.id_pekerjaan);
            submitData.append("identity", this.formData.identity);
            submitData.append("ref", this.noReferensi);

            if (this.formData.foto) submitData.append("foto", this.formData.foto);
            if (this.formData.ttl) {
              const ttlDate = new Date(this.formData.ttl).toISOString().split("T")[0];
              submitData.append("ttl", ttlDate);
            }
            if (this.formData.identity === "1") {
              submitData.append("noKtp", this.formData.noKtp);
              submitData.append("uploadKtp", this.formData.uploadKtp);
            } else if (this.formData.identity === "2") {
              submitData.append("golonganSim", this.formData.golonganSim);
              submitData.append("noSim", this.formData.noSim);
              let masaBerlakuSimDate = "";
              if (this.formData.masaBerlakuSim) {
                masaBerlakuSimDate = new Date(this.formData.masaBerlakuSim).toISOString().split("T")[0];
              }
              submitData.append("satpasPenerbit", this.formData.satpasPenerbit);
              submitData.append("uploadSim", this.formData.uploadSim);
              submitData.append("masaBerlakuSim", masaBerlakuSimDate);
            }
            for (let pair of submitData.entries()) {
              console.log(pair[0], pair[1]);
            }

            console.log("uploadSim:", this.formData.uploadSim);
            console.log(this.formData.uploadSim instanceof File);
            const resKonfirm = await postKonfirmasiPelanggar(submitData);

            if (!resKonfirm.data?.success) {
              throw { response: resKonfirm, message: resKonfirm.data?.message || 'Konfirmasi pelanggar gagal diproses.' };
            }

            const litsusData = new FormData();
            litsusData.append("no_ref", this.noReferensi);
            litsusData.append("milik", this.milik);

            if (this.confirmationType == 2) {

              litsusData.append("status", "SANGGAHAN");
              litsusData.append(
                "confirmation_type",
                this.confirmationType
              );
              litsusData.append(
                "litsus_code",
                this.confirmationType
              );
              litsusData.append("alasan_sanggah", this.alasan || "");

              if (this.idTipeSanggahan) {
                litsusData.append("id_sanggahan", this.idTipeSanggahan);
              }

              if (this.namaTipeSanggahan) {
                litsusData.append("tipe_sanggahan", this.namaTipeSanggahan);
              }

              if (this.uploadBukti instanceof File) {
                litsusData.append("upload_dokumen", this.uploadBukti);
              }

              console.log("UPLOAD BUKTI:", this.uploadBukti);
              console.log("IS FILE:", this.uploadBukti instanceof File);

              for (const [key, value] of litsusData.entries()) {
                console.log("FORMDATA:", key, value);
              }

              await postKonfirmasiLitsus(litsusData);

              await Swal.fire({
                title: "Sanggahan Berhasil Dikirim",
                text: "Data sanggahan Anda telah berhasil dikirim dan akan dilakukan proses verifikasi oleh petugas.",
                icon: "success",
                confirmButtonText: "OK",
              });

              location.reload();
              return;
            }

            litsusData.append("status", "TERKONFIRMASI");
            litsusData.append("alasan_sanggah", this.alasan || "Menerima hasil konfirmasi pelanggaran.");

            await getPenerbitanBriva(this.noReferensi, this.noPolisi);

            Swal.fire({
              title: "Data Terkonfirmasi",
              text: "Apabila Saudara telah mengisi surat konfirmasi sebagai bukti pelanggaran, selanjutnya saudara dapat mengecek status pembayaran denda tilang.",
              icon: "success",
            }).then(() => {
              localStorage.setItem("showCekPelanggaran", "true");
              this.$router.push({
                path: "/cek-pelanggaran",
                query: {
                  ref_number: this.noReferensi,
                  plates: this.noPolisi,
                },
              });
            });

          } catch (error) {
            console.info("Error submit form step 4:", error);

            if (error.status === 400 || error.status === false || error.response?.status === 400) {
              const warningMessage = `
              <div style="text-align: center; font-size: 20px; line-height: 1.6; color: #4a5568;">
                  <p style="margin-bottom: 12px;">
                    Pelanggaran Daya Angkut (Overloading) diberikan <b>PERINGATAN</b> maka segera menyesuaikan berat muatan sesuai Jumlah Berat yang Diizinkan (JBI).
                  </p>
                  <p style="margin-bottom: 0;">
                    Mulai <b>1 Januari 2027</b>, pelanggaran Daya Angkut akan dikenakan denda sesuai ketentuan peraturan perundang-undangan.
                  </p>
              </div>
               `;

              await Swal.fire({
                title: "Pemberitahuan",
                html: warningMessage,
                icon: "warning",
                confirmButtonText: "OK"
              });

              location.reload();
              return;
            }
            Swal.fire({
              title: "Kesalahan!",
              text: "Terjadi kesalahan saat memproses permintaan ke server.",
              icon: "error",
            });
          } finally {
            this.isSubmitting = false;
          }
        }
      });
    },
    convertDateFormat(dateString) {
      if (!dateString) return "";
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.status-wrapper {
  background: #fff;
  padding: 35px;
  border-radius: 16px;
  border: 1px solid #cbd5e1;
}

.status-header {
  margin-bottom: 30px;
}

.status-header h3 {
  font-size: 30px;
  font-weight: normal;
  color: #0f2f5f;
  margin-bottom: 12px;
}

.instruction-text {
  color: #2d3748;
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
}

.simple-choice {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.choice-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 28px;
  border: 2px solid #cbd5e1;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
  background: #fff;
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.choice-item:hover {
  border-color: #2563eb;
  background: #f8fafc;
}

.choice-item input {
  width: 22px;
  height: 22px;
  accent-color: #2563eb;
  cursor: pointer;
}

.choice-item:has(input:checked) {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1e40af;
}

.table-responsive {
  width: 100%;
}

.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px;
}

.modern-table th,
.modern-table td {
  padding: 16px 20px;
  vertical-align: middle;
  font-size: 18px;
}

.modern-table th {
  width: 35%;
  text-align: left;
  font-weight: normal;
  color: #1e293b;
  background: #f1f5fb;
  border-radius: 10px 0 0 10px;
  border-left: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.question-header {
  line-height: 1.5;
  color: #000000 !important;
}

.modern-table td {
  color: #000000;
  background: #ffffff;
  border-radius: 0 10px 10px 0;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  border-right: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.section-row td {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  font-weight: normal;
  color: #0f2f5f;
  padding: 24px 0 8px 4px;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.modern-table .form-control {
  width: 100%;
  border-radius: 8px;
  border: 2px solid #cbd5e1;
  padding: 12px 16px;
  font-size: 18px;
  background-color: #fff;
  color: #000;
  transition: border-color 0.2s;
}

.modern-table .form-control:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: none;
}

input[type="file"] {
  font-size: 16px;
  padding: 8px 0;
}

.file-helper {
  display: block;
  margin-top: 8px;
  color: #475569;
  font-size: 15px;
  line-height: 1.5;
}

.alert-box {
  background-color: #fffbeb;
  border: 2px solid #fef3c7;
  border-left: 6px solid #d97706;
  color: #78350f;
  padding: 16px 20px;
  border-radius: 10px;
  font-size: 17px;
  line-height: 1.6;
}

.tabs {
  display: flex;
  gap: 12px;
}

.tab-btn {
  padding: 10px 24px;
  border: 2px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #334155;
  font-size: 17px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-danger-custom {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.btn-danger-custom:hover {
  background: #fca5a5;
}

.media-full-cell {
  background: #f8fafc !important;
  padding: 20px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 12px !important;
}

.media-box-full {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullFrame-view {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  border: 3px solid #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.action-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
}

.btn-back {
  background: #f1f5f9;
  color: #334155;
  border: 2px solid #cbd5e1;
  padding: 0 24px;
  height: 56px;
  border-radius: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-back:hover {
  background: #e2e8f0;
}

.btn-next {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  border: none;
  padding: 0 32px;
  height: 56px;
  border-radius: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-next:hover {
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
}

.text-danger {
  color: #dc2626 !important;
}

.disclaimer-box {
  margin-top: 24px;
  padding: 18px 22px;
  background: #fff8e6;
  border: 1px solid #f5c542;
  border-left: 5px solid #f0ad00;
  border-radius: 10px;
}

.disclaimer-box h5 {
  margin: 0 0 10px;
  color: #8b4513;
  font-weight: 600;
}

.disclaimer-box p {
  margin-bottom: 8px;
}

.disclaimer-box ol {
  margin: 0;
  padding-left: 22px;
}

.disclaimer-box li {
  margin-bottom: 6px;
  line-height: 1.6;
}

.form-check {
  margin-top: 14px;
}

.form-check-input {
  cursor: pointer;
}

.form-check-label {
  cursor: pointer;
  font-weight: 500;
  color: #1f2937;
}

.btn-next:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 768px) {
  .status-wrapper {
    padding: 20px 16px;
  }

  .modern-table,
  .modern-table tbody,
  .modern-table tr,
  .modern-table th,
  .modern-table td {
    display: block;
    width: 100% !important;
  }

  .modern-table tr:not(.section-row) {
    margin-bottom: 12px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    overflow: hidden;
  }

  .modern-table th {
    padding: 12px 14px;
    font-size: 16px;
    background: #f8fafc;
    border: none;
    border-bottom: 1px solid #e2e8f0;
    border-radius: 0;
  }

  .modern-table td {
    padding: 14px 14px;
    font-size: 17px;
    border: none;
    border-radius: 0;
  }

  .simple-choice {
    flex-direction: column;
    gap: 10px;
  }

  .choice-item {
    width: 100%;
    justify-content: flex-start;
  }

  .section-row td {
    padding: 16px 0 4px 4px;
    font-size: 14px;
  }

  .action-group {
    flex-direction: column-reverse;
    gap: 12px;
  }

  .btn-back,
  .btn-next {
    width: 100%;
    height: 58px;
    font-size: 17px;
  }

  .pdf-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 24px;
    color: #dc2626;
    font-size: 16px;
    text-align: center;
    word-break: break-word;
  }

  .pdf-preview i {
    font-size: 48px;
  }
}
</style>